import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import PropTypes from 'prop-types';

import { acceptInvitation }  from './actions';
import { redirectToTenant } from '../../actions'
import Callback from '../../components/Callback';
import ErrorPage from '../../components/error/ErrorPage';
import {getJsonQueryString, serverLog} from '../../common/utils';
import {CIG_SSO} from '../../common/constants';
import { invitedTenant, inviteErrorInfo, loading } from './selectors';



export const ErrorBodyComp = () => {
    const emsg1 = `The invitation link is a one time use link and you may see this message if you have previously accepted your invitation to join Data Infrastructure Insights. ` +
            'Please navigate to Data Infrastructure Insights from NetApp Console to access your tenant.'
    const emsg2 = 'If you have not yet previously accepted your invitation and are seeing this message, ' +
            'please note that the invitation email address must match your NetApp Console account email address. In addition, ' +
            'the invitation to join Data Infrastructure Insights is only valid for a limited period and you will need a new invitation if the current one has expired.';
    return (
        <React.Fragment>
            <p>{emsg1}</p>
            <p>{emsg2}</p>
        </React.Fragment>
    );
};
ErrorBodyComp.displayName = 'ErrorBodyComp';


export function CigAcceptInvitation({ auth, tenant, errorInfo, isLoading, redirectToTenant, acceptInvitation}) {
    let inviteId = '';

    const acceptInvite = () => {
        let qStr = getJsonQueryString(sessionStorage.getItem(CIG_SSO.sessionKey));
        if (qStr) {
            sessionStorage.removeItem(CIG_SSO.sessionKey);
            inviteId = _.get(qStr, 'context', '');
        }
        // Corner case where the context (inviteId) is in query string but not  in session storage.
        if (_.isEmpty(inviteId)) {
            qStr = getJsonQueryString(window.location.search);
            inviteId = _.get(qStr, 'context', '');
        }
        acceptInvitation(auth, inviteId);
    };

    useEffect(() => {
        if ((_.isNil(errorInfo) || _.isNil(errorInfo.errorMessage)) && !isLoading) {
            acceptInvite();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorInfo]);

    useEffect(() => {
        if (!_.isUndefined(_.get(tenant,'id'))) {
            const tenantId = tenant.id;
            redirectToTenant(window, auth, tenantId);
        }

        if (!_.isNil(errorInfo.errorMessage)) {
            const logMessage = 'AcceptInvitation: useEffect - Failed to accept the invitation. Error code: ' + _.get(errorInfo, 'errorCode', '');
            const error = {
                category: 'ERROR',
                logMessage: logMessage + ' Error message:' + (_.get(errorInfo, 'errorMessage') || ''),
            };
            serverLog(auth, error);
        }
    },[ tenant, errorInfo.errorMessage, errorInfo.errorCode, auth, errorInfo, redirectToTenant ]);

    if (isLoading && _.isUndefined(errorInfo.errorMessage)) {
        return <Callback/>;
    }

    return (
        <div>
            {
                !_.isNil(errorInfo.errorMessage) && !_.isEmpty(errorInfo.errorMessage) && (
                    <ErrorPage
                        id="invite-error"
                        title="We could not find your invite."
                        serverMsg={errorInfo.errorMessage}
                        errorCode={errorInfo.errorCode}
                        httpStatusCode={errorInfo.httpStatusCode}
                        auth={auth}
                        logPrefix={'CigAcceptInvitation: inviteId: ' + inviteId}>

                        <ErrorBodyComp id="invite_error_comp"/>
                    </ErrorPage>
                )
            }
        </div>
    );
}

CigAcceptInvitation.propTypes = {
    auth: PropTypes.object,
    errorInfo: PropTypes.object,
    tenant: PropTypes.object.isRequired,
    acceptInvitation: PropTypes.func.isRequired,
    redirectToTenant: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
};

CigAcceptInvitation.displayName = 'CigAcceptInvitation';

function mapStateToProps(state){
    return {
        tenant: invitedTenant(state),
        errorInfo: inviteErrorInfo(state),
        isLoading: loading(state),
    }
}
export default connect(
    mapStateToProps,
    {
        acceptInvitation,
        redirectToTenant,
    }
)(CigAcceptInvitation);
